// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"288":"4be3c443","364":"6cc70c95","772":"75254090","996":"e0174901"}[chunkId] + ".js";
};